// removed by extract-text-webpack-plugin
module.exports = {"container":"bw5k3XrYnXLULYgzpeDFn","marketCode":"WBcYIV2K7D14F7kE7uCMC"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Markets/Mobile/Name/styles.css
// module id = 1610
// module chunks = 83